"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var SearchResultBarItem = /** @class */ (function (_super) {
    __extends(SearchResultBarItem, _super);
    function SearchResultBarItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showSubMenu: true,
        };
        return _this;
    }
    SearchResultBarItem.prototype.onMouseOver = function (e) {
        if (this.props.onMouseOver) {
            this.props.onMouseOver();
            e.preventDefault();
        }
    };
    SearchResultBarItem.prototype.render = function () {
        var _a = this.props, title = _a.title, count = _a.count, shortTitle = _a.shortTitle, imageUrl = _a.imageUrl, url = _a.url, className = _a.className, icon = _a.icon, selected = _a.selected, openOnNewTab = _a.openOnNewTab;
        var showSubMenu = this.state.showSubMenu;
        var display = 'none';
        if (showSubMenu) {
            display = 'block';
        }
        var selectedShortTitle = shortTitle ? shortTitle : title;
        var displayCount = count >= 0 ? count.toLocaleString('en') : '';
        if (count > 9999) {
            displayCount = '9,999+';
        }
        if (count >= 0) {
            displayCount = "(" + displayCount + ")";
        }
        else if (count == '-') {
            displayCount = "( " + count + " )";
        }
        return (react_1.default.createElement("div", { onMouseOver: this.onMouseOver.bind(this), style: { flex: '0 0 auto' } },
            react_1.default.createElement("a", { className: "searchResultLink  " + (selected ? 'selected' : '') + " " + (className ? className : ''), href: url, target: openOnNewTab ? '_blank' : '_self' },
                icon && react_1.default.createElement("div", { className: "naviLinkLogo " + icon }),
                react_1.default.createElement("div", { className: "title" }, title),
                react_1.default.createElement("div", { className: "number" },
                    react_1.default.createElement("span", { style: { verticalAlign: 'middle' } }, displayCount)))));
    };
    SearchResultBarItem.propTypes = {
        title: prop_types_1.default.any.isRequired,
        count: prop_types_1.default.any,
        shortTitle: prop_types_1.default.any,
        icon: prop_types_1.default.string,
        url: prop_types_1.default.string,
        selected: prop_types_1.default.bool,
        openOnNewTab: prop_types_1.default.bool,
        className: prop_types_1.default.string,
        onMouseOver: prop_types_1.default.func,
    };
    return SearchResultBarItem;
}(react_1.default.Component));
exports.default = SearchResultBarItem;
